export default __webpack_public_path__ + "static/media/e_minor.4eb79e14.jpg";